import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Details } from '@/core/domain/reservation/models/details.model';
import { DetailsRepository } from '@/core/domain/reservation/repositories/details.repository';
import { PromotionRepository } from '@/core/domain/promotions/respository/promotion.repository';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DetailsInterface } from '@/core/domain/details/models/details.model';
import { environment } from '@/env/environment';
import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';

@Injectable({
    providedIn: 'root',
})
export class PromotionImplRepository extends PromotionRepository {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
    ) {
        super();
    }
    override getPromotions(): Observable<any> {
        const currentLanguage = this.getLanguageUseCase.execute().language;
        const headers = new HttpHeaders({
            lang: currentLanguage,
        });
        const url = [
            environment.alamoApi.BASE_HOST,
            environment.alamoApi.ENDPOINTS.featuredPromotions,
        ].join('/');

        return this.httpClient.get(url, {});
    }
}
